import React from "react"
import PropTypes from "prop-types"

// Helper component to display an output input box
export const OutputLine = ({ type: showOutput, varname, value = "" }) => {
  return (
    <input
      type={showOutput ? "text" : "hidden"}
      id={varname}
      name={varname}
      value={value !== null ? value : ""}
      onChange={() => {}}
      style={{
        width: "80%"
      }}
      readOnly
    />
  )
}
OutputLine.propTypes = {
  type: PropTypes.bool.isRequired,
  varname: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ])
}
